import React from 'react';
import { FONTS, TYPOGRAPHY } from '@/styles';
import {
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

interface Props {
  backgroundColor: string;
  labelStyle?: StyleProp<ViewStyle>;
  text: string;
  textStyle?: StyleProp<TextStyle>;
}

export const Label: React.FC<Props> = ({
  backgroundColor,
  labelStyle,
  text,
  textStyle,
}) => {
  return (
    <View style={styles.container}>
      <View style={[{ backgroundColor }, labelStyle]}>
        <Text
          numberOfLines={1}
          style={[TYPOGRAPHY.xsmall, styles.text, textStyle]}
        >
          {text}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
  },
  text: {
    ...FONTS.primaryBold,
    lineHeight: 22,
    paddingHorizontal: 8,
    textTransform: 'uppercase',
  },
});
